import { GlobalPlayerButton } from '@tunasong/audio-ui'
import { useSelector } from '@tunasong/redux'
import { BackButton } from '@tunasong/ui-lib'
import type { CSSProperties, HTMLAttributes, JSX, Ref } from 'react'

interface HeaderProps extends HTMLAttributes<HTMLDivElement> {
  hideOnScrollTarget?: Node
  breadcrumbs?: JSX.Element
  controls?: JSX.Element | (JSX.Element | null)[]
  /** Show status icons - connectivity, MIDI, etc.  */
  showStatus?: boolean
  /** Show Back button */
  showBackButton?: boolean
  color?: string
  position?: string
  elevation?: number
  ref?: Ref<HTMLDivElement>
}

const appBarStyle: CSSProperties = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 1100,
}

const toolbarStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-between',
  backgroundColor: 'var(--tuna-palette-layers)',
  zIndex: 1,
  color: 'var(--tuna-palette-action-disabled)',
  height: 48,
  gap: 8,
  alignItems: 'center',
  padding: '0 8px',
}

export const Header = (props: HeaderProps) => {
  const {
    showBackButton = true,
    ref,
    controls,
    breadcrumbs,
    showStatus = true,
    color: _color,
    position: _position,
    elevation: _elevation,
    ...restProps
  } = props
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)

  /** Show spinner if loading songs */
  if (!isLoggedIn) {
    return null
  }

  return (
    <div style={appBarStyle} {...restProps} ref={ref}>
      <div style={toolbarStyle}>
        {showBackButton ? (
          <BackButton
            style={{
              display: 'flex',
              alignItems: 'center',
              paddingLeft: 0,
              paddingRight: 0,
              minWidth: 32,
            }}
          />
        ) : (
          <div style={{ width: 32 }} />
        )}
        <div style={{ flex: 1 }}>{breadcrumbs}</div>

        <GlobalPlayerButton showStatus={showStatus} />

        {controls}
      </div>
    </div>
  )
}
